import React from 'react';
import PropTypes from 'prop-types';

import styles from './Tag.scss';

const Tag = ({ children, onClick, active = false }) => (
  <div className={active ? styles.blue : styles.default} onClick={onClick}>
    {children}
  </div>
);

Tag.propTypes = {
  active: PropTypes.bool,
  onClick: PropTypes.func,
};

export default Tag;
